import { createContext } from 'react'

export const queryId = {
  getData: 'getChartData'
}

export const queryOptions = {
  enabled: false,
  refetchOnWindowFocus: false,
  cacheTime: Infinity
}

export const filterSelectColors = {
  backgroundColor: {
    selected: '#DEE2E6',
    focused: '#007BFF'
  },
  textColor: {
    selected: '#212529',
    focused: '#FFFFFF'
  },
  dropdownIndicator: '#495057'
}

export const mq = {
  tablet: '(max-width: 1024px)',
  mobile: '(max-width: 750px)'
}

export const lineChartOptions = {
  responsive: true,
  layout: {
    padding: 20
  },
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      backgroundColor: 'rgba(51, 51, 51, 1)',
      titleColor: 'rgba(194, 199, 208, 1)',
      titleFont: {
        family: 'Source Sans Pro',
        weight: 400,
        size: 16
      },
      bodyColor: 'rgba(255, 255, 255, 1)',
      bodyFont: {
        family: 'Source Sans Pro',
        weight: 600,
        size: 18
      },
      cornerRadius: 4,
      displayColors: false
    },
    datalabels: {
      backgroundColor: '#333333',
      borderRadius: 4,
      color: '#FFFFFF',
      align: 'right',
      offset: 0,
      font: {
        family: 'Source Sans Pro',
        weight: 400,
        size: 16,
        lineHeight: 1.5
      },
      formatter: function (value, context) {
        if (context.dataIndex === context.dataset.data.length - 1) {
          return value.y
        }
        return null
      }
    }
  },
  scales: {
    y: {
      position: 'right',
      beginAtZero: true,
      ticks: {
        color: '#212529'
      }
    },
    x: {
      ticks: {
        color: '#212529'
      }
    }
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem) {
        return tooltipItem.yLabel
      }
    }
  },
  interaction: {
    mode: 'nearest',
    axis: 'x',
    intersect: false
  },
  datasets: {
    line: {
      fill: true,
      borderColor: 'rgba(0, 123, 255, 1)',
      backgroundColor: 'rgba(60, 141, 188, 0.4)'
    }
  },
  elements: {
    point: {
      radius: 0
    }
  }
}

export const initialReducerState = {
  filterData: new FormData(),
  chartData: null,
  tableData: null,
  todayData: null
}

export const AppContext = createContext(null)

export const formId = 'lineChartForm'
